<!-- Overlay (visible when drawer is open on mobile) -->
@if (isDrawerOpen()) {
  <div
    class="settings-side-nav__overlay"
    (click)="closeDrawer()"
    aria-hidden="true"
  ></div>
}

<!-- Desktop Nav / Mobile Drawer -->
<div
  class="settings-side-nav"
  [class.settings-side-nav--open]="isDrawerOpen()"
>
  <!-- Navigation Sections -->
  <div class="settings-side-nav__content">
    @for (section of sections(); track section.title) {
      <app-settings-side-nav-section
        [title]="section.title"
        [items]="section.items"
        [selectedItemId]="selectedItemId()"
        (itemClicked)="onItemClick($event)"
      />
    }
  </div>
</div>

<!-- Floating Close Button (visible only on mobile when drawer is open) -->
@if (isDrawerOpen()) {
  <button
    class="settings-side-nav__close-button"
    (click)="closeDrawer()"
    type="button"
    aria-label="Close navigation menu"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
}
